<template>
  <b-card no-body>
    <template>
      <h6 class="title">{{ info.name }}</h6>
    </template>
    <b-row no-gutters class="info">
      <item-card :title="translate.result.cardReseller.email + ':'" :text="email" />
      <item-card :title="translate.result.cardReseller.phone + ':'" :text="info.cellphone" />
      <item-card :title="translate.result.cardReseller.whatsapp + ':'" :text="info.phone" />
      <item-card :title="translate.result.cardReseller.address + ':'" :text="info.address.address" />
      <item-card :title="translate.result.cardReseller.city + ':'" :text="city" />
      <item-card :title="translate.result.cardReseller.zipcode + ':'" :text="info.address.zipcode" />
    </b-row>
    <buttons-card 
      :phone="info.cellphone || ''" 
      :whatsapp="info.phone || ''"
    />
  </b-card>
</template>

<script>
import ButtonsCard from "./ButtonsCard.vue";
import ItemCard from "./ItemCard.vue";

export default {
  name: "distributor-card",
  props: {
    info: {
      type: Object,
      required: true,
    },
  },
  components: {
    ItemCard,
    ButtonsCard,
  },
  computed: {
    translate() {
      return this.$store.getters.translate;
    },
    email() {
      return this.info.email.split(",")[0];
    },
    city() {
      const { city, state } = this.info.address;
      if (city && state) {
        return `${city}  -  ${state}`;
      }
      return "";
    },
  },
};
</script>
<style lang="scss" scoped>
.info {
  display: flex;
  flex-direction: column;
}

.title {
  text-align: center;
  font-size: 16px;
  margin-bottom: 1rem;
}

.card {
  display: flex;
  justify-content: center;
  padding: 1.5rem;
  width: 100%;
  max-width: 420px;
  font-size: 12px;
  margin-bottom: 10px;
  border: 1px solid #dfe0e0;
  border-radius: 5px;
  background: #fff;
}
</style>
